import { Box } from '@mui/material';
import { Typography, colors } from '@sweep-io/sweep-design';
import { CenteredCircularProgress } from '../common/CenteredCircularProgress';

const ScanningIndicator: React.FC = () => {
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
      }}
    >
      <CenteredCircularProgress size={16} />
      <Typography variant="body" color={colors.blue[500]}>
        Scanning
      </Typography>
    </Box>
  );
};

export default ScanningIndicator;
